import { render } from "./TabloBoyut.vue?vue&type=template&id=05b80b5a&scoped=true"
import script from "./TabloBoyut.vue?vue&type=script&lang=js"
export * from "./TabloBoyut.vue?vue&type=script&lang=js"

import "./TabloBoyut.vue?vue&type=style&index=0&id=05b80b5a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\cosku\\OneDrive\\Masaüstü\\DiyetisyenYagmurDemir\\GT Yönetim Sistemi - Kopya\\Yönetim Sistemi - Frontend\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b80b5a"]])

export default __exports__